import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHellofreshComponent } from './simple-icons-hellofresh.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHellofreshComponent ],
    exports:      [ SimpleIconsHellofreshComponent ],
    bootstrap:    []
})
export class SimpleIconsHellofreshModule {}
